import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Users, School, FileText, BookOpen, Award, TrendingUp, Calendar, MessageSquare } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get(`${V1}/admin/stats`).then((r) => setStats(r.data)); }, []);

  const cards = [
    { icon: Users, label: "Toplam Kullanıcı", value: stats?.users_total, tone: "primary" },
    { icon: School, label: "Kayıtlı Okul", value: stats?.schools, tone: "accent" },
    { icon: Calendar, label: "Bursluluk Sınavı", value: stats?.scholarship_exams, tone: "primary" },
    { icon: FileText, label: "Başvuru", value: stats?.applications, tone: "success" },
    { icon: BookOpen, label: "Soru", value: stats?.questions, tone: "primary" },
    { icon: TrendingUp, label: "Deneme Sınavı", value: stats?.mock_exams, tone: "accent" },
    { icon: MessageSquare, label: "Davet", value: stats?.invitations, tone: "primary" },
    { icon: Award, label: "Çözülen Sınav", value: stats?.exam_sessions, tone: "success" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <div className="overline text-accent">Süper Admin</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Sistem Kontrol Paneli</h1>
        <p className="text-muted-foreground mt-2">SanoStudent platform istatistikleri</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c, i) => (
          <div key={i} className="p-6 rounded-xl border border-border bg-card" data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <c.icon className={`h-6 w-6 mb-3 ${c.tone === "accent" ? "text-accent" : c.tone === "success" ? "text-success" : "text-primary"}`} />
            <div className="text-3xl font-display font-bold">{c.value ?? "—"}</div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
